export const NB_SLIDES_MOBILE = 1
export const NB_SLIDES_TABLET = 2
export const NB_SLIDES_DESKTOP = 3

export const SLIDES_TO_SCROLL = 1
export const MAX_PRODUCTS = 8
